import { MisField } from "../../interfaces/ActionStartResponse";
import { iEnquiryPropertiesProps } from "./EnquiryPropertiesModal";
import "./index.scss";

export default function MIS(props: iEnquiryPropertiesProps) {
    const { enquiryDetails } = props;
    const fields = enquiryDetails?.misModel?.fields ?? [];
    const entries = enquiryDetails?.misData ?? [];

    function getValue(field: MisField): string {
        const entry = entries.find(e => e.fieldID === field.id);
        if (!entry || !entry.value) return "";

        if (field.fieldType === "Dropdown" || field.fieldType === "TextWithDropdown") {
            const lookup = field.lookupValues?.find(l => l.id.toString() === entry.value);
            return lookup ? lookup.name : entry.value;
        }
        if (field.fieldType === "Checkbox") {
            return entry.value === "1" ? "Yes" : "No";
        }
        return entry.value;
    }

    return (
        <div>
            {fields.map(field => {
                if (field.fieldType === "DisplayTitle") {
                    return (
                        <div
                            className="row rowMarginControl"
                            key={"mis-field-" + field.id}
                        >
                            <div className="col-sm-12">
                                <h6 className="font-bold">{field.label}</h6>
                            </div>
                        </div>
                    );
                }
                if (field.fieldType === "DisplayGap" || field.fieldType === "DisplayDivider") {
                    return <hr key={"mis-field-" + field.id} />;
                }

                return (
                    <div
                        className="row rowMarginControl"
                        key={"mis-field-" + field.id}
                    >
                        <div className="col-sm-4">
                            <label className="g-label">{field.label}</label>
                        </div>
                        <div className="col-sm-8">
                            <label className="g-label">{getValue(field)}</label>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
